import { ErrorHandler, inject, Injectable, NgZone } from '@angular/core'

import { CRASH_REPORTER } from '@utils/crash-reporter'

/**
 * Angular's `ErrorHandler` that also sends what it receives to Bugfender as a crash: errors in event handlers, change
 * detection, lifecycle hooks and effects, and promises rejected inside the Angular zone. Angular's own handler only
 * prints them with the console it captured before Bugfender replaced it, so none of them reached Bugfender.
 *
 * Reporting runs outside the Angular zone: Angular calls this handler from inside the zone in several places, and a
 * failure in the SDK's own work would otherwise come back here as another crash. It never throws, so a failing report
 * cannot hide the original error.
 */
@Injectable()
export class CrashErrorHandler extends ErrorHandler {
	readonly #zone = inject(NgZone)
	readonly #reporter = inject(CRASH_REPORTER)

	override handleError(error: unknown): void {
		super.handleError(error)

		try {
			this.#zone.runOutsideAngular(() => this.#reporter.reportAngularError(error))
		} catch {
			return
		}
	}
}
